import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Spinner from 'components/shared/Spinner';
import styles from './loading.module.scss';

function TableLoading(props) {
  return (
    <div
      className={classnames([
        styles.loadingContainer,
        {
          [styles.initialLoadingContainer]: props.isInitialLoading,
          [styles.fullHeightContainer]: props.hasMaxHeight
        }
      ])}>
      <div
        className={classnames([
          styles.loadingOverlay,
          { [styles.initialLoadingOverlay]: props.isInitialLoading },
          { [styles.maxHeightInitialOverlay]: props.hasMaxHeight && props.isInitialLoading }
        ])}
      />
      <div className={styles.spinnerContainer}>
        <Spinner />
      </div>
    </div>
  );
}

TableLoading.propTypes = {
  isInitialLoading: PropTypes.bool,
  hasMaxHeight: PropTypes.bool
};

TableLoading.defaultProps = {
  isInitialLoading: false,
  hasMaxHeight: false
};

export default memo(TableLoading);
